import { Message } from "@/modules/Notification/models/Message";
import { NotificationSchudule } from "@/modules/Notification/models/NotificationSchudule";
import { NOTIFICATION_CONSTANTS } from "@/modules/Profile/constants/ProfileConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { Notification } from "../../../../Notification/models/Notification";
import Vuetify from "vuetify";
import { Http } from "@status/codes";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { SERVICES_ACCESS } from "@/modules/Services/constants/ServicesConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { NotificationService } from "@/modules/Notification/services/NotificationService";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
Vue.use(Vuetify);

@Component({
  name: "NotificationData",
  components: {
    ModalTemplate
  }
})
export default class NotificationData extends Vue {
  [x: string]: any;
  @Prop() public notification!: NotificationSchudule;
  @Inject() notificationService!: NotificationService;

  LABELS = NOTIFICATION_CONSTANTS.LABELS_DETAILS;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  statesToShowResend = [
    NOTIFICATION_CONSTANTS.STATIC_EXECUTED,
    NOTIFICATION_CONSTANTS.STATIC_CANCELATION,
    NOTIFICATION_CONSTANTS.STATIC_RESEND
  ];
  dialogConfirmation = false;
  modalConfirmationText =
    NOTIFICATION_CONSTANTS.MESSAGE_MODAL.TEXT_CONFIRMATION;
  modalConfirmationTitle =
    NOTIFICATION_CONSTANTS.MESSAGE_MODAL.RESEND_CONFIRMATION;

  async reSendNotification(notification: NotificationSchudule) {
    try {
      const notificationData: Notification = {
        message: new Message()
      };

      if (
        !(notification.message && notification.userId && notification.channels)
      ) {
        Snackbar.popError(
          NOTIFICATION_CONSTANTS.MESSAGES_RESPONSE.INSUFFICIENT_DATA
        );
        return;
      }

      notificationData.message = notification.message;
      notificationData.channels = notification.channels;
      notificationData.channelsKeys = notification.channelsKeys || [];
      notificationData.userId = notification.userId;
      notificationData._key = notification._key;

      Snackbar.popInfo(NOTIFICATION_CONSTANTS.MESSAGES_RESPONSE.SENDING);
      const responseNotification = await this.notificationService.sendNotification(
        notificationData
      );

      if ((responseNotification.code = Http.Ok)) {
        Snackbar.popSuccess(NOTIFICATION_CONSTANTS.MESSAGES_RESPONSE.SUCCESS);
        this.$emit(NOTIFICATION_CONSTANTS.REFRESH_NOTIFICATION_LIST);
        return;
      }

      Snackbar.popError(responseNotification.message);
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${SERVICES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;
      Snackbar.popError(errorMessage);
    }
  }

  showModalConfirmation() {
    this.dialogConfirmation = true;
  }

  handleModalAccept(notification: NotificationSchudule) {
    this.reSendNotification(notification);
    this.dialogConfirmation = false;
  }
  handleModalCancel() {
    this.dialogConfirmation = false;
  }
}
